<template>
  <div class="dynamic_item" :class="{hasMargin: hasMargin}">
    <div class="top">
      <div class="img_box">
        <img :src="imgUrl" onerror="this.src='//img.webloom.cn/img/logo/default-user.png';this.onerror=null" alt="">
      </div>
      <div class="member">
        <div class="name">{{menber}}</div>
        <div class="time" v-if="time">{{$utils.timestampToStr(new Date(time), 'Y.M.D h:m')}}</div>
      </div>
    </div>
    <div class="contant" v-text="content"></div>
  </div>
</template>

<script>
export default {
  props: {
    imgUrl: {
      type: String,
      default: '../../assets/img/user.png'
    },
    content: {
      type: String,
      default: ''
    },
    menber: {
      type: String,
      default: '某某某'
    },
    time: {
      type: Number,
      default: 1
    },
    hasMargin: {
      type: Boolean,
      default: true
    }
  }
}
</script>

<style lang="less" scoped>
.dynamic_item {
  padding: 24px 0px;
  border-bottom: 1px solid #EBEEF5;
  &.hasMargin {
    margin: 0 32px;
  }
  .top {
    display: flex;
    .img_box {
      height: 48px;
      width: 48px;
      border-radius: 50%;
      overflow: hidden;
      img {
        height: 48px;
        width: 48px;
      }
    }
    .member {
      margin-left: 8px;
      .time {
        font-size: 12px;
        color: #909399;
      }
    }
  }
  .contant {
    font-size: 14px;
    color: #303133;
    margin-top: 8px;
    text-overflow: -o-ellipsis-lastline;
    overflow: hidden;
    text-overflow: ellipsis;
    display: -webkit-box;
    -webkit-line-clamp: 4;
    line-clamp: 4;
    -webkit-box-orient: vertical;
    word-break:break-word;
  }
}
</style>



// WEBPACK FOOTER //
// src/components/team-homepage/DynamicItem.vue